import React from "react";
import { FaHandPointUp } from "react-icons/fa";

let Pointer = () => (
  <div
    className="sidebarPointer"
    style={{
      position: "fixed",
      top: "80px",
      left: "80px"
    }}
  >
    <FaHandPointUp
      style={{
        height: "50px",
        width: "50px",
        transform: "rotate(-30deg)"
      }}
    />
  </div>
);

export default Pointer;
